module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "position-back"
  }, [_c('div', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Previous step")])])])]), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "features address-info"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control is-medium is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.worker),
      expression: "worker"
    }],
    staticClass: "input is-medium",
    class: {
      'is-danger': _vm.hasErrors
    },
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.worker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.worker = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-medium",
    class: {
      'is-success': !_vm.hasErrors
    },
    attrs: {
      "disabled": _vm.hasErrors
    },
    on: {
      "click": _vm.select
    }
  }, [_c('span', [_vm._v("Next")])])])]), (_vm.errorWorkerMessage) ? _c('p', {
    staticClass: "help help-small notif-danger"
  }, [_vm._v(_vm._s(_vm.errorWorkerMessage))]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Set a custom worker name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-helvetica step-explanation"
  }, [_c('span', [_vm._v("A worker name is required for joining our pools, it will show up on your stats. We generate a random worker name by default but you may change it to differentiate your PC / system performance on your stats.")]), _c('br'), _c('span', [_vm._v("A worker name must not contain spaces or special characters (besides \"_\" or \"-\")")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-247cb5b4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_worker.vue
// module id = 366
// module chunks = 1